// LIBRARIES
import { createAsyncThunk } from "@reduxjs/toolkit";

// MISC
import { REST } from "config/axiosConfig";
import { ISettingsProperties } from "models/interfaces";

export const getSettings = createAsyncThunk(
  "settings/get-settings",
  async () => {
    try {
      const response = await REST.get(`/settings/get-settings`);
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const updateSettings = createAsyncThunk(
  `/settings/updateSettings`,
  async (data: ISettingsProperties) => {
    try {
      const response = await REST.post(
        "settings/create-or-edit-settings",
        data
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);
